"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _app = require("@package/app");

var _socket = require("@package/socket");

var _notification = require("@widget/notification");

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _Notifications = _interopRequireDefault(require("./Notifications"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function Widget() {
  try {
    var handlerToggle = function handlerToggle() {
      setOpen(!isOpen);
    };

    var handleViewAll = function handleViewAll() {
      setOpen(!isOpen);
      navigate(process.env['PUBLIC_URL'] + '/notifications');
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var items = (0, _reactRedux.useSelector)(_notification.selectItems);
    var wrapperRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isOpen = _useState2[0],
        setOpen = _useState2[1];

    (0, _react.useEffect)(function init() {
      function handleResetState(event) {
        var wrapperElement = wrapperRef['current'];

        if (wrapperElement) {
          var target = event['target'];

          if (!wrapperElement.contains(target)) {
            setOpen(false);
          }
        }
      }

      (0, _socket.on)('action', function (data) {
        if (data['type'] === 'notificationCreated') {
          dispatch((0, _notification.addNotificationAction)(data['payload']));
        }
      });
      document.addEventListener('click', handleResetState);
      return function () {
        (0, _socket.off)('action');
        document.removeEventListener('click', handleResetState);
      };
    }, []);
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: wrapperRef,
      className: _defaultsModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['control'],
      onClick: function onClick(event) {
        return handlerToggle(event);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultsModule["default"]['icon'], 'icon-notifications', (0, _defineProperty2["default"])({}, _defaultsModule["default"]['icon--active'], isOpen))
    }), !!items.length && /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultsModule["default"]['marker']
    })), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['list']
    }, /*#__PURE__*/_react["default"].createElement(_Notifications["default"], {
      onViewAll: function onViewAll() {
        return handleViewAll();
      }
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Widget;
exports["default"] = _default;